import { render, staticRenderFns } from "./ActivityDetail.vue?vue&type=template&id=03d5ada6&scoped=true"
import script from "./ActivityDetail.vue?vue&type=script&lang=js"
export * from "./ActivityDetail.vue?vue&type=script&lang=js"
import style0 from "./ActivityDetail.vue?vue&type=style&index=0&id=03d5ada6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d5ada6",
  null
  
)

export default component.exports